import React, { createContext, useContext } from 'react';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

interface NetworkStatusContextType {
  isOnline: boolean;
  retryCount: number;
  maxRetries: number;
  hasExhaustedRetries: boolean;
}

const NetworkStatusContext = createContext<NetworkStatusContextType | null>(null);

export const useNetworkStatusContext = () => {
  const context = useContext(NetworkStatusContext);
  if (!context) {
    throw new Error('useNetworkStatusContext must be used within a NetworkStatusProvider');
  }
  return context;
};

export const NetworkStatusProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const networkStatus = useNetworkStatus();

  return (
    <NetworkStatusContext.Provider value={networkStatus}>
      {children}
    </NetworkStatusContext.Provider>
  );
}; 